<template>
  <a-table
    :columns="columns"
    :data-source="fileList"
    :pagination="false"
    :scroll="{ x: 950}"
    rowKey="id"
  >
  <span slot="index"
              slot-scope="text, record, index">
          {{ index + 1 }}
        </span>
    <span slot="action"
              slot-scope="text, record">
          <a style="color: #1890ff" @click="showDetailDrawer(record)">查看详情</a>
        </span>
  </a-table>
</template>

<script>
// 企业台账表格列名
const columns = [
  {
    title: "序号",
    width: 60,
    scopedSlots: { customRender: "index" },
  },
  {
    title: "权证编号",
    width: 260,
    dataIndex: "certificateNumber",
  },
  {
    title: "权证类型",
    width: 100,
    dataIndex: "propertyType",
  },

  {
    title: "权证地点",
    width: 280,
    dataIndex: "certificateAddress",
  },
  {
    title: "权利人名称",
    width: 280,
    dataIndex: "obligeeName",
  },
  {
    title: "操作",
    fixed: "right",
    width: 180,
    scopedSlots: { customRender: "action" },
  },
];
export default {
  props: {
    form: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      columns,
      fileList:[{
        "assetId":0,
        "certificateNumber":"沪房地金字（2010）第016967号",
        "propertyType":"产权",
        "certificateAddress":"蒙山路101号",
        "obligeeName":"上海今晨企业发展有限公司"
      }]
    };
  },
  methods:{
    showDetailDrawer(record){
      console.log(record);
      
    }
  }
};

</script>

<style>
</style>